export default {
  submitButton: {
    id: 'merchant_register_form_submit_button',
    defaultMessage: 'Get started',
  },
  userSubtitle: {
    id: 'merchant_register_form_user_subtitle',
    defaultMessage: 'Tell us about yourself',
  },
  companyLabel: {
    id: 'merchant_register_form_company_label',
    defaultMessage: 'Company',
  },
  sellerAgreementCheckBox: {
    id: 'merchant_register_form_seller_agreement_checkbox',
    defaultMessage: 'I own or manage a refurbished-electronics company.',
  },
  referralCodeInput: {
    id: 'merchant_register_form_referral_code_input_label',
    defaultMessage: 'Referral code (optional)',
  },
  referralCodeInputDescription: {
    id: 'merchant_register_form_referral_code_input_description',
    defaultMessage:
      'If referred by a Back Market representative, enter your unique code above.',
  },
  textTerms: {
    id: 'merchant_register_form_text_terms',
    defaultMessage:
      'These fields are mandatory. As the party responsible for data processing, Back Market uses the collected data to manage our contractual relationship, for protection from fraud, to carry out analyses and surveys, and for marketing operations. For more information on the use of your personal data or your rights, you can check {termsAndConditions, html} or send an email to {email, html}',
  },
  termsAndConditions: {
    id: 'merchant_register_form_terms_and_conditions_link',
    defaultMessage: 'our Terms and Conditions',
  },
  emailAddress: {
    id: 'merchant_register_form_email',
    defaultMessage: 'legal@backmarket.com',
  },
  fieldIsRequired: {
    id: 'merchant_register_form_fields_required',
    defaultMessage: 'This field is required',
  },
  companyInvalid: {
    id: 'merchant_register_form_fields_company_invalid',
    defaultMessage: 'The company name contains invalid characters',
  },
  invalidLength: {
    id: 'merchant_register_form_fields_company_invalid_length',
    defaultMessage: 'This field is too long',
  },
  streetInvalid: {
    id: 'merchant_register_form_fields_street_invalid',
    defaultMessage: 'The street name contains invalid characters',
  },
  cityInvalid: {
    id: 'merchant_register_form_fields_city_invalid',
    defaultMessage: 'The city name contains invalid characters',
  },
  dontOwnCompany: {
    id: 'merchant_register_dont_own_company',
    defaultMessage: "Don't own a company?",
  },
  sellOnBuyBack: {
    id: 'merchant_register_sell_on_buyback',
    defaultMessage: 'Sell your personal devices on BuyBack',
  },
  emailLabel: {
    id: 'input_email_label',
    defaultMessage: 'Email',
  },
  emailRequired: {
    id: 'input_email_required',
    defaultMessage: 'The email field is required',
  },
  emailInvalid: {
    id: 'input_email_invalid',
    defaultMessage: 'This email seems to be invalid',
  },
  passwordLabel: {
    id: 'input_password_new_label',
    defaultMessage: 'Password',
  },
  passwordRequired: {
    id: 'input_password_new_required',
    defaultMessage: 'The password field is required',
  },
  passwordInvalid: {
    id: 'input_password_new_invalid',
    defaultMessage:
      'At least {minLength} characters, including 1 uppercase letter, 1 lowercase letter and 1 number. Because you can never be too sure.',
  },
  eCommerceSelectLabel: {
    id: 'merchant_register_form_e-commerce_select_label',
    defaultMessage: 'Previous year’s company revenue (optional)',
  },
}
